// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Products_SalvarInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/products/salvar
 *
 * Creates or updates a product. When so_product_id is provided, updates existing;
 * otherwise creates new. Price is stored in cents (multiply by 100).
 */
import { registerContract } from './validate'

export interface Products_SalvarInput {
so_product_name: string
so_product_category_id: number
so_product_id?: number
so_product_description?: string
so_product_default_price?: number
so_product_sku?: string
so_product_unit_of_measure?: string
so_product_track_stock?: number
so_product_franchise_id?: number
}

registerContract('Products_SalvarInput', {
  so_product_name:            { type: 'string',  required: true },
  so_product_category_id:     { type: 'number',  required: true },
  so_product_id:              { type: 'number',  required: false },
  so_product_description:     { type: 'string',  required: false },
  so_product_default_price:   { type: 'number',  required: false },
  so_product_sku:             { type: 'string',  required: false },
  so_product_unit_of_measure: { type: 'string',  required: false },
  so_product_track_stock:     { type: 'number',  required: false },
  so_product_franchise_id:    { type: 'number',  required: false },
})
